// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__ihY8Y","author":"Table_author__exv1k","authorImage":"Table_authorImage__3TGxa","unreadRow":"Table_unreadRow__3PhTF"};